// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___z8eD3","overlayModal":"style__overlayModal____5tIF","overlayModalInner":"style__overlayModalInner___1ut1v","overlayCloseButton":"style__overlayCloseButton___2l1dP","overlayModalTitle":"style__overlayModalTitle___2u8KD","overlayModalText":"style__overlayModalText___xMbcT","overlayModalTextBold":"style__overlayModalTextBold___dB8dh","overlayModalButtons":"style__overlayModalButtons___QcD7f","overlayModalButtonsItem":"style__overlayModalButtonsItem___1OUko","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___3GJwc","buttonActive":"style__buttonActive___16LUT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-coupon/style.css
// module id = 1256
// module chunks = 0